/** Mobile hides labels so both toggles fit beside the other Composer actions on the compact rail. */
export function getAskModeToggleLabelVisibility(isMobileStyle) {
    return isMobileStyle ? 'never' : 'always';
}
//# sourceMappingURL=getAskModeToggleLabelVisibility.js.map